import {List, Text} from '@mantine/core';
import React from 'react';

import {AntibodyEnforcedNamingStrategySpec} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {getShouldAddNamingStrategies} from 'antibodies/schema-configuration/schema-migration/schemaMigrationNamingStrategies';
import {LABELING_STRATEGY_TO_TEXT, RegistryLabelingStrategy} from 'constants/RegistryConstants';
import {NamingStrategy} from 'graphql-client/__generated/graphqlGlobalTypes';
import getTestProps from 'test/lib/cypress/getTestProps';

import MigrationPreviewSection from './MigrationPreviewSection';

export interface NamingStrategyMigrationPreviewProps {
  enforcedNamingStrategySpec: AntibodyEnforcedNamingStrategySpec;
  existingNamingStrategies: Array<RegistryLabelingStrategy> | null;
  applicableNamingStrategies: Array<NamingStrategy>;
}

export default function NamingStrategyMigrationPreview({
  enforcedNamingStrategySpec,
  existingNamingStrategies,
  applicableNamingStrategies,
}: NamingStrategyMigrationPreviewProps): JSX.Element {
  const shouldAddNamingStrategies = getShouldAddNamingStrategies(
    enforcedNamingStrategySpec,
    existingNamingStrategies
  );

  if (!shouldAddNamingStrategies) {
    return (
      <MigrationPreviewSection title="Labeling strategies" description="No changes to labeling strategies." />
    );
  }

  return (
    <MigrationPreviewSection
      title="Labeling strategies"
      description="The following labeling strategies will be added to the schema."
    >
      <List size="sm" {...getTestProps({component: 'NamingStrategyMigrationPreview', element: 'strategies'})}>
        {applicableNamingStrategies.map((strategy) => (
          <List.Item key={strategy}>
            <Text size="sm">
              {
                LABELING_STRATEGY_TO_TEXT[
                  RegistryLabelingStrategy[strategy as keyof typeof RegistryLabelingStrategy]
                ]
              }
            </Text>
          </List.Item>
        ))}
      </List>
    </MigrationPreviewSection>
  );
}
